import { ChangeHandler, ControllerRenderProps } from "react-hook-form"

import { legacyFilter } from "./legacyFilter"

const filterInvalidUsernameCharacters = (
  field: ControllerRenderProps<any, any>,
) => {
  const { onChange, ...restOfField } = field

  const filterInvalidChars: ChangeHandler = async (e) => {
    const value = legacyFilter(e.target.value)
    if (!/[^0-9a-zA-Z-_@.]/.test(value) || value === "") onChange(e)
  }
  return { ...restOfField, onChange: filterInvalidChars }
}

const filterInvalidFiscalCodeUsernameCharacters = (
  field: ControllerRenderProps<any, any>,
) => {
  const { onChange, ...restOfField } = field

  const filterInvalidChars: ChangeHandler = async (e) => {
    const value = legacyFilter(e.target.value)
    if (!/[^0-9a-zA-Z-_.]/.test(value) || value === "") onChange(e)
  }
  return { ...restOfField, onChange: filterInvalidChars }
}

export {
  filterInvalidFiscalCodeUsernameCharacters,
  filterInvalidUsernameCharacters,
}
